module.exports = "https://static.zego.com/_next/static/images/partner2-f286380edbd5352ed8d35418474c9d2d.png";